import { logError, SDKLogger } from '../logging'

/** Convenience helper to log an error with optional structured metadata. */
export function captureError(
  e: Error,
  logger: SDKLogger,
  meta?: Record<string, unknown>,
): void {
  logError(logger, e.message, e, meta)
}
